const smartlookIdentify = async (uuid, options) => {
   if(window.smartlook){
      await window.smartlook('identify', uuid, options);
   }
}
const smartlookInit = async () => {
   const newScript = document.createElement('script');
   newScript.innerText  = `
      window.smartlook||(function(d) {
         var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
         var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
         c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
         })(document);
         smartlook('init', '8b2a5a854cfa184795ad21c047870b0b58ddb000', { region: 'eu' });
   `;
   document.head.appendChild(newScript);
}
const smartlookPause = async () => {
   if(window.smartlook){
      await window.smartlook('pause');
   }
}
const smartlookResume = async () => {
   if(window.smartlook){
      await window.smartlook('resume');
   }
}

export {
   smartlookIdentify,
   smartlookInit,
   smartlookPause,
   smartlookResume,
}
